module.exports = __webpack_public_path__ + "assets/img/961587019294_.pic_hd.f1754ade.jpg";